module.exports = __webpack_public_path__ + "img/no_seal.88645a1c.png";